import { createContext, useContext, useEffect, useState } from 'react';
import { get, getSession, onSessionChange, post, setSession } from './api.js';
import { navigate, useLocation } from './router.jsx';
import { Spinner } from './ui.jsx';
import { t } from './i18n.js';

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [session, setS] = useState(getSession());
  const [ready, setReady] = useState(!getSession());
  useEffect(() => onSessionChange(setS), []);
  useEffect(() => {
    if (!getSession()) return;
    get('/v1/users/me').then(({ data }) => setSession({ ...getSession(), user: data }), () => setSession(null)).finally(() => setReady(true));
  }, []);
  const value = {
    user: session?.user || null,
    signIn: (data) => setSession(data),
    signOut: async () => {
      try { await post('/v1/auth/logout', { refresh_token: getSession()?.refresh_token }); } catch { /* session may already be gone */ }
      setSession(null);
      navigate('/');
    },
    reloadUser: async () => { const { data } = await get('/v1/users/me'); setSession({ ...getSession(), user: data }); return data; },
  };
  if (!ready) return <Spinner />;
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

// Wraps pages that need a signed-in user (and optionally a role).
export function Guard({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  useEffect(() => { if (!user) navigate(`/login?next=${encodeURIComponent(loc.path + loc.search)}`, { replace: true }); }, [user, loc.path, loc.search]);
  if (!user) return null;
  if (roles && !roles.includes(user.role)) return <div className="note bad">{t('บัญชีของคุณไม่มีสิทธิ์ใช้หน้านี้', 'Your account does not have access to this page')}</div>;
  return children;
}
